import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/assets/style/global.scss'
import VueSimpleMarkdown from 'vue-simple-markdown'
import 'vue-simple-markdown/dist/vue-simple-markdown.css'
import 'vuetify';

Vue.config.productionTip = false
Vue.use(VueSimpleMarkdown)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
